import React, { useEffect, useState } from 'react'
import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridItemChangeEvent,
    GridPageChangeEvent,
    GridPagerSettings,
    GridRowProps,
    GridSortChangeEvent,
    GridNoRecords
  } from "@progress/kendo-react-grid";
import { useNavigate } from 'react-router-dom';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { Icon } from '@iconify/react';


const ActivePositions = (props: any) => {
 

  const initialSort: Array<SortDescriptor> = [
    { field: props.status === 'closed' ? "closedCount" : "resourceCount", dir: "desc" },
  ];
  const [sort, setSort] = useState(initialSort);

  const navigate = useNavigate()
  
  const redirection = (jobId: string, positionName: string, companyName: string) => {
    navigate('../position-details', { state: { jobId: jobId, positionName: positionName, companyName: companyName }})
  }
  
  const jobRole = (props: GridCellProps, redirection: any) => {
    return(
    <td>
      <div className="userInfo" onClick={() => redirection(props.dataItem.jobId, props.dataItem.positionName, props.dataItem.company)}>
        {props.dataItem.job_role.name}
      </div>
      </td>
    )
  }
  
  return (
      <div>
        <Grid
        data={props && props.data && orderBy(props.data,sort)} 
        sortable={true}
        sort={sort}
        onSortChange={(e:GridSortChangeEvent) => {setSort(e.sort);}}
        >
          <GridNoRecords>
            <div className="noData">
              <Icon icon="mdi:smiley-neutral-outline" />
              No data to display
            </div>
          </GridNoRecords>
          
            {/* <Column field="positionName" title="Title" /> */}
            <Column field="job_role" title="Role" cell={(props: GridCellProps) => jobRole(props, (candidateLoginId: string, positionName: string, companyName: string) => redirection(candidateLoginId, positionName, companyName))}/>
            <Column field={props.status === 'closed' ? "closedCount" : "resourceCount"} title="Number of Positions" />
            <Column field="submittedCount" title="Candidates Submitted" />

        </Grid>  
    </div>
  )
}

export default ActivePositions